// extracted by mini-css-extract-plugin
module.exports = {"searchPO":"SearchPO_searchPO__5kjDg","requiredIndicator":"SearchPO_requiredIndicator__3ek3O","searchWrap":"SearchPO_searchWrap__2SK-Z","collapsed":"SearchPO_collapsed__62DS6"};